import React, { useEffect } from 'react'

interface HelmetProps {
  title: string
  description: string
  children: React.ReactNode
}

export const Helmet = ({ title, description, children }: HelmetProps) => {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'description';
    meta.content = description 
    document.getElementsByTagName('head')[0].appendChild(meta)
    document.title = title
  }, [description, title])

  return (
    <>
      {children}
    </>
  )
}
